
import { PageBase } from '@/core/models/shared';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';

@Component
export default class Avatar extends PageBase{
    @Prop() private src!: string;
    @Prop() private nome!: string;

    iniciais: string = "";

    mounted() {
        this.GetIniciais();
    }
    
    GetIniciais(){
        var rawTeste = this.nome.split(" ");
        if(rawTeste.length > 1){
            this.iniciais += rawTeste[0].trim().charAt(0);
            this.iniciais += rawTeste[rawTeste.length - 1].trim().charAt(0);
        }
        else{
            this.iniciais = rawTeste[0].trim().charAt(0);
        }
    }
}
